import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from '../../common';

import './_style.css';

function AlternativeLoader({ visible }) {
  if (!visible) {
    return null;
  }

  return (
    <div className="AlternativeLoader">
      <Loader visible />
    </div>
  );
}

AlternativeLoader.propTypes = {
  visible: PropTypes.bool.isRequired
};

export default AlternativeLoader;
